import projectData from "../data/project.json";
import ProjectDetails from "./project-details";

const Projects = () => {
  const { projects } = projectData;

  return (
    <div className="projects section-padding">
      <div className="container">
        <div className="row">
          <div
            className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="section-title-center text-center">
              <span>Projects</span>
              <h2 className="display-6">Some of my projects</h2>
              <div className="section-divider divider-traingle"></div>
            </div>
          </div>
        </div>
        <div className="row">
          {projects.map((data, i) => (
            <ProjectDetails key={data.id} data={data} i={i} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
